import { Modal, Spin, Tag } from "antd";
import React, { useEffect, useState } from "react";
import GetUnitApi from "../../api/GetUnitApi";

function UnitDetailsModal(props) {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (props.unitId) {
      setLoading(true);
      getUnitDetails(props.unitId);
    }
  }, [props.unitId]);

  async function getUnitDetails(id) {
    const apiResponse = await GetUnitApi(id);
    if (apiResponse.message === "success") {
      setData(apiResponse);
      setLoading(false);
    }
  }

  function handleCancel() {
    setData();
    props.handleCancel();
  }

  return (
    <Modal
      title="Unit details"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Spin spinning={loading}>
        <div className="grid grid-cols-2">
          <div className="mb-3">
            <div className="text-xs">Name</div>
            <div>{data?.unit?.name || "-"}</div>
          </div>
          <div className="mb-3">
            <div className="text-xs">Level</div>
            <Tag color={data?.unit?.organizationLevel?.color}>
              {data?.unit?.organizationLevel?.name || "-"}
            </Tag>
          </div>
          <div className="mb-3">
            <div className="text-xs">Head unit</div>
            <div>{data?.unit?.headUnit?.name || "-"}</div>
          </div>
          <div className="mb-3">
            <div className="text-xs">Sub units</div>
            <div>{data?.subUnitsCount || "0"}</div>
          </div>
          <div className="">
            <div className="text-xs">Users</div>
            <div>{"0"}</div>
          </div>
          <div className="">
            <div className="text-xs">Unit head</div>
            <div>{"-"}</div>
          </div>
        </div>
      </Spin>
    </Modal>
  );
}

export default UnitDetailsModal;
